export enum PluginState {
  paused = 0,
  idle,
  busy,
  versionConflict,
  testmode,
  faulted
}
